import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import ckeditor from 'ckeditor4-vue'
import ToastedPlugin from 'vue-toasted'
import BackToTop from 'vue-backtotop'
import { VueHammer } from 'vue2-hammer'
import VueCryptojs from 'vue-cookies'
import VueGtag from 'vue-gtag'
import VueViewer from 'v-viewer'
import VueApexCharts from 'vue-apexcharts'
import VueMeta from 'vue-meta'
import VueLazyload from 'vue-lazyload'
import VueVirtualScroller from 'vue-virtual-scroller'
import VueSidebarMenu from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
// import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import 'firebase/messaging'
import * as commonFunction from './components/commonFunction'
import * as errorAPI from './error'

Vue.config.productionTip = false
Vue.config.errorHandler = function (err, vm, info) {
  const currentPageURL = window.location.href

  // 에러 처리 로직
  console.error('Error occurred on page:', currentPageURL)
  console.error('에러가 발생한 컴포넌트:', vm.$options.name)
  console.error('에러 메시지:', err.message)
  let errorFile = currentPageURL + ' / ' + vm.$options.name
  let errorMessage = err.message
  errorAPI.setLogSystemError(id, password, errorFile, errorMessage)
}

let id = ''
let password = ''
Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.focus()
  }
})
Vue.use(BackToTop)
Vue.use(ckeditor)
Vue.use(VueHammer)
Vue.use(VueCryptojs)
Vue.use(ToastedPlugin)
Vue.use(VueMeta)
Vue.use(VueLazyload)
Vue.use(VueSidebarMenu)
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
Vue.use(VueViewer)
Vue.use(VueVirtualScroller)
Vue.use(VueGtag, {
  config: {
    id: 'G-CQF5CKGH15',
    params: {
      send_page_view: false
    }
  }
}, router)
Vue.filter('passwordDot', function (value) {
  if (!value) return ''
  return value.replace(/./g, '•')
})

// if ('Notification' in window && 'serviceWorker' in navigator) {
//   navigator.serviceWorker.register('/firebase-messaging-sw.js')
//     .then(res => console.log('파이어베이스 서비스워커 등록성공 ', res))
//     .catch(err => console.log('파이어베이스 서비스워커 등록실패', err))
// };

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  created () {
    if (this.$store.getters['userStore/getUserID'] !== '') {
      id = this.$store.getters['userStore/getUserID']
      password = this.$store.getters['userStore/getPassword']
      // this.$gtag.set({
      //   user_id: this.$store.getters['userStore/getUserID']
      // })
      this.newPush()
    }
  },

  methods: {

    setLogSystemError (errorFile, errorMessage) {
      if (this.$store.getters['userStore/getUserID'] !== '') {
        errorAPI.setLogSystemError(this.$store.getters['userStore/getUserID'], this.$store.getters['userStore/getPassword'], errorFile, errorMessage)
      }
    },

    newPush () {
      let payload = {
        id: this.$store.getters['userStore/getUserID'],
        password: this.$store.getters['userStore/getPassword']
      }
      this.$store.commit('pushStore/mutationReset', payload)
    }

  }
}).$mount('#app')
